export default "/images/519d952d86e8595ec0ccfab511607a91.avif";